<ng-template #openTicketModal>
  <div>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "MENU.OPEN_SUPPORT_REQUEST" | translate }}</h3>
      <div class="form-group">
        <label [for]="'title'">{{ "TITLE" | translate }}<sup class="text-danger">*</sup></label>
        <input type="text" class="form-control" [(ngModel)]="title" id="title" />
      </div>
      <div class="form-group">
        <label [for]="'category'">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          [(ngModel)]="category"
          id="category"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [searchable]="true"
          [closeOnSelect]="true"
          [clearable]="true"
          [items]="categoriesTicket"
          [openOnEnter]="false"
          [virtualScroll]="true"
        >
        </ng-select>
        <div class="font-error" *ngIf="showErrors && (!category || category < 1)">{{ "ERRORS.FIELD_CATEGORY" | translate }}</div>
      </div>
      <div class="form-group">
        <label [for]="'note'">{{ "ERRORS.INSERT_MESSAGE" | translate }}<sup class="text-danger">*</sup></label>
        <angular-editor [config]="_utilService.defaultEditorConfig" id="note" [(ngModel)]="note"></angular-editor>
        <div class="font-error" *ngIf="showErrors && (!note || note.length < 1)">{{ "ERRORS.FIELD_MESSAGE" | translate }}</div>
      </div>
      <div class="form-group">
        <label for="invoice_attachments">{{ "ATTACHMENTS" | translate }}</label>
        <div id="invoice_attachments" class="custom-file">
          <input class="custom-file-input" type="file" lang="it" id="custom-file-input" [multiple]="true" accept="image/*, application/pdf, .doc, .docx" (change)="addAttachmentToList($any($event).target.files)" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
      </div>
      <div class="form-group pt-1" *ngIf="attachmentsListObj.length > 0">
        <div *ngFor="let attachment of attachmentsListObj; let i_attachment = index" class="d-flex border-bottom mb-1 pb-1">
          <div class="flex-basis-60 d-flex align-items-center">
            <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i_attachment)" *ngIf="attachment.status === 0">
              <i [data-feather]="'x'" class="text-danger" size="18"></i>
            </div>
            <div class="mt-025">{{ attachment.name }}</div>
          </div>
          <div class="flex-basis-20 text-right">{{ attachment.size }}</div>
        </div>
        <div>{{ "TOTAL" | translate }}: {{ attachmentsListObj.length }}</div>
      </div>
      <div>
        <a class="font-small-3 text-primary" (click)="showVideo()">
          {{ "DONT_KNOW_HOW_TO_DO" | translate }}
        </a>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()">{{ "CANCEL" | translate }}</button>
      <button (click)="sendTicket()" type="submit" class="btn btn-primary w-150">{{ "SEND" | translate }}</button>
    </div>
  </div>
</ng-template>
